if (document.querySelector(".tabs")) {
  setTimeout(() => {
    document.querySelectorAll(".tabs__list li").forEach((elem) => {
      if (window.location.href.indexOf(elem.dataset.anchor) >= 0) {
        elem.click();
      }
    });
  }, 1000);
}